import React from 'react';
import TableInsights from 'src/components/sharedComponents/Tablas/TableInsights/TableInsights';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import ViewResult from 'src/components/insigthFactory/viewResult/ViewResult';
import ReturnButton from '../ReturnButton';

const TestAccept = (props) => {
  const {
    testAccept, onAcceptTest, onRejectTest, unidades, onCloseView, onOpenView, openResult, result, fetchUrl, onClickReturn
  } = props;

  const columns = [
    { title: 'ID', field: 'id', hidden: true },
    { title: 'NOMBRE', field: 'usuario.nombre' },
    { title: 'APELLIDO', field: 'usuario.apellido' },
    { title: 'CORREO', field: 'usuario.correo' },
    { title: 'TITULO INSIGHT', field: 'entrada_sistema.titulo' },
    {
      title: 'UNIDAD DE NEGOCIO',
      field: 'entrada_sistema.id_unidad_negocio',
      render: (rowData) => {
        const unidadNegocio = unidades
          .filter((unidad) => unidad.id === rowData.entrada_sistema.id_unidad_negocio).pop();
        return (<td>{`${unidadNegocio?.unidad}`}</td>);
      },
    },
    {
      title: 'FECHA',
      render: (rowData) => <td>{`${rowData.fecha?.slice(0, 10)}`}</td>,
    },
  ];

  return (
    <>
      <CardTitle title="Aceptar resultados de los insights" />
      <ReturnButton label='Volver' onClick={onClickReturn} />
      <ViewResult
        openResult={openResult}
        onCloseResult={onCloseView}
        result={result}
        fetchUrl={fetchUrl}
      />
      <TableInsights
        isResult
        hiddenEdit
        columns={columns}
        title="Resultados"
        dataTable={testAccept}
        onAcceptTest={onAcceptTest}
        onRejectTest={onRejectTest}
        onOpenView={onOpenView}
      />
    </>
  )
};

export default TestAccept;
